import { Box, Grid, Link, Stack, Typography } from "@mui/material";

export default function Footer() {
  const links = [
    // { label: 'About Us', href: '/about' },
    { label: "About Us", href: "" },
    { label: "Careers", href: "" },
    { label: "News", href: "" },
    { label: "Sitemap", href: "" },
    { label: "Contact Us", href: "" },
  ];

  const termsprivacy = [
    { label: "Terms and Conditions", href: "/termsConditions" },
    { label: "Privacy Policy", href: "/privacyPolicy" },
  ];

  return (
    <>
    <Box sx={{marginTop:'50px'}}>
      <Box
        sx={{ position: "relative", justifyContent: "center", display: "flex" }}
      >
        <Box
          sx={{
            background: "url(lightdots.png) no-repeat",
            position: "absolute",
            height: "200px",
            width: "550px",
            backgroundSize: "contain",
          }}
        ></Box>
      </Box>
      <Box
        sx={{
          textAlign: "center",
          marginTop: "100px",
        }}
      >
        <img src="logo.png" width={150} />
      </Box>

      <Box>
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            fontFamily: "Urbanist",
            color: "#acacac",
            fontSize: "18px",
            fontWeight: "500",
            margin: "30px 0",
          }}
        >
          India's <span style={{ color: "#fff" }}>Smartest</span> Real Estate
          Portal
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              marginTop: "10px",
            }}
          >
            <span
              style={{
                background: "#acacac",
                height: "1px",
                width: "100px",
                display: "block",
              }}
            ></span>
          </Box>
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          divider={
            <Typography
              component="span"
              sx={{ fontSize: "14px", color: "#acacac" }}
            >
              |
            </Typography>
          }
        >
          {links.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              underline="none"
              sx={{
                color: "#acacac",
                "&:hover": {
                  color: "#FFD00D",
                  textDecoration:'underline',
                },
                fontSize: "16px",
              }}
            >
              {link.label}
            </Link>
          ))}
        </Stack>

        <Stack
          sx={{ marginTop: "20px" }}
          direction="row"
          spacing={2}
          justifyContent="center"
          divider={
            <Typography
              component="span"
              sx={{ fontSize: "14px", color: "#acacac" }}
            >
              |
            </Typography>
          }
        >
          {termsprivacy.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              underline="none"
              sx={{
                color: "#acacac",
                "&:hover": {
                  color: "#FFD00D",
                  textDecoration:'underline',
                },
                fontSize: "16px",
              }}
            >
              {link.label}
            </Link>
          ))}
        </Stack>

        <Typography
          variant="h6"
          style={{
            textAlign: "center",
            color: "#acacac",
            marginTop: "20px",
            fontSize: "16px",
            fontWeight: "normal",
            fontFamily: "Urbanist",
          }}
        >
          © 2025 aa<span style={{ color: "#FFD00D" }}>o</span>naa.com
        </Typography>
      </Box>

      <video
        src="footeranimation.mp4"
        autoPlay
        muted
        loop
        style={{ width: "100%", height: "auto", display: "block" }}
      />

      </Box>
    </>
  );
}
